import React, { useState, useEffect } from 'react';
import { ProgressBar } from 'primereact/progressbar';

const ProgressBarLoader = ({ isLoading, duration = 4000, onComplete, style }) => {
  const [progress, setProgress] = useState(0);

  useEffect(() => {
    let interval;

    if (isLoading) {
      setProgress(0); // Reset progress
      interval = setInterval(() => {
        setProgress((prevProgress) => {
          const nextProgress = prevProgress + 10; // Increment progress
          if (nextProgress >= 100) {
            clearInterval(interval);
            if (onComplete) onComplete(); // Trigger callback on completion
            return 100;
          }
          return nextProgress;
        });
      }, duration / 10); // Adjust based on duration
    } else {
      setProgress(0); // Reset when loading stops
    }

    return () => clearInterval(interval); // Cleanup
  }, [isLoading, duration, onComplete]);

  if (!isLoading) return null; // Don't render if not loading

  return <ProgressBar value={progress} displayValueTemplate={() => ''}  style={{ height: '2px', ...style }} />;
};

export default ProgressBarLoader;
